import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideEchartsCore } from 'ngx-echarts';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';

import { environment } from '../environments/environment';
import { ThemePreset } from '@/styles/theme-preset';
import { routes } from './app.routes';
import { BrowserGlobalRef, GlobalRef } from './shared/globals/global-ref';
import { ReferenceDataService } from './shared/services/reference-data.service';
import { UserContextService } from './shared/services/user-context.service';
import { requestInterceptor } from './shared/globals/request.interceptor';
import {
  CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  CustomBearerTokenCondition,
  customBearerTokenInterceptor,
  provideKeycloak,
} from 'keycloak-angular';

registerLocaleData(localeRu);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withHashLocation()),

    provideKeycloak({
      config: {
        url: environment.keycloakUrl,
        realm: environment.keycloakRealm,
        clientId: environment.keycloakClientId,
      },
    }),
    {
      provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [
        {
          // как раньше: токен во все запросы, кроме статики
          shouldAddToken: async (req, _next, keycloak) =>
            !!keycloak.authenticated && !req.url.startsWith('/assets/statics/'),
        },
      ] satisfies CustomBearerTokenCondition[],
    },
    provideHttpClient(
      withInterceptors([customBearerTokenInterceptor, requestInterceptor])
    ),
    provideAppInitializer(async () => {
      const userContextSvc = inject(UserContextService);
      const referenceDataSvc = inject(ReferenceDataService);
      await userContextSvc.initialize();
      if (userContextSvc.currentUser) {
        await firstValueFrom(referenceDataSvc.init());
      }
    }),

    { provide: GlobalRef, useClass: BrowserGlobalRef },
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    provideEchartsCore({ echarts: () => import('echarts') }),
    provideMatomo(
      {
        siteId: environment.siteId,
        trackerUrl: '//matomo-new.x5.ru/',
        enableLinkTracking: false,
        runOutsideAngularZone: true,
        trackAppInitialLoad: false,
      },
      withRouter()
    ),
    providePrimeNG({
      theme: {
        preset: ThemePreset,
        options: { darkModeSelector: false },
      },
    }),
  ],
};
